import { getMobFactory } from "../../serialization";
import type { Mob } from "../../mob";

export interface MobSpawnConfigEntry {
	mobType: string;
	share: number;
}

export class MobSpawnerConfig {
	private entries: MobSpawnConfigEntry[] = [];

	getEntries(): MobSpawnConfigEntry[] {
		return this.entries;
	}

	addEntry(entry: MobSpawnConfigEntry): void {
		this.entries.push(entry);
	}

	getMobToSpawn(): Mob | null {
		const totalShares = this.entries.reduce((sum, e) => sum + e.share, 0);
		if (totalShares <= 0) return null;

		let random = Math.random() * totalShares;
		for (const entry of this.entries) {
			random -= entry.share;
			if (random <= 0) return getMobFactory(entry.mobType)();
		}
		return null;
	}

	serialize(): { entries: MobSpawnConfigEntry[] } {
		return {
			entries: this.entries.map((e) => ({ mobType: e.mobType, share: e.share })),
		};
	}

	static deserialize(data: any): MobSpawnerConfig {
		const config = new MobSpawnerConfig();
		if (data?.entries) {
			for (const entry of data.entries) {
				config.addEntry({ mobType: entry.mobType, share: entry.share });
			}
		}
		return config;
	}
}
